import { AssignRoleDialog } from '@/modules/administration/components/dialogs/AssignRoleDialog';
import { AssignTenantDialog } from '@/modules/administration/components/dialogs/AssignTenantDialog';
import { ManageRolesDialog } from '@/modules/administration/components/dialogs/ManageRolesDialog';
import { ManageTenantsDialog } from '@/modules/administration/components/dialogs/ManageTenantsDialog';
import { UserTable } from '@/modules/administration/components/UserTable';
import { useUserAdministration } from '@/modules/administration/hooks/useUserAdministration';
import { Card, CardContent } from '@/modules/ui/components/card/Card';
import Container from '@/modules/ui/components/container/Container';
import { Input } from '@/modules/ui/components/input/Input';
import { PageHeader } from '@/modules/ui/components/page-header/PageHeader';

export const UserAdministration = () => {
  const {
    users,
    companies,
    isLoading,
    searchKeyword,
    onSearchChange,
    assignModalVisible,
    setAssignModalVisible,
    assignRoleModalVisible,
    setAssignRoleModalVisible,
    selectedUser,
    manageTenantsUser,
    setManageTenantsUser,
    manageRolesUser,
    setManageRolesUser,
    availableCompanies,
    handleAssignClick,
    handleAssignRoleClick,
    handleAssignSubmit,
    handleAssignRoleSubmit,
    handleRemoveTenant,
    handleRemoveRole,
    handleSetDefaultTenant,
    isAssignTenantPending,
    isAssignRolePending,
  } = useUserAdministration();

  return (
    <Container>
      <PageHeader title="User Administration" />

      <div className="mb-6 flex items-center justify-between">
        <Input
          placeholder="Search users..."
          value={searchKeyword}
          onChange={onSearchChange}
          className="max-w-sm"
        />
      </div>

      <Card>
        <CardContent className="p-0">
          <UserTable
            users={users}
            companies={companies}
            isLoading={isLoading}
            onAssignTenant={handleAssignClick}
            onAssignRole={handleAssignRoleClick}
            onManageTenants={setManageTenantsUser}
            onManageRoles={setManageRolesUser}
            onRemoveTenant={handleRemoveTenant}
            onRemoveRole={handleRemoveRole}
            onSetDefaultTenant={handleSetDefaultTenant}
          />
        </CardContent>
      </Card>

      <ManageTenantsDialog
        user={manageTenantsUser}
        onClose={() => setManageTenantsUser(null)}
        companies={companies}
        onSetDefault={handleSetDefaultTenant}
        onRemove={handleRemoveTenant}
      />

      <ManageRolesDialog
        user={manageRolesUser}
        onClose={() => setManageRolesUser(null)}
        onRemove={handleRemoveRole}
      />

      <AssignTenantDialog
        open={assignModalVisible}
        onOpenChange={setAssignModalVisible}
        user={selectedUser}
        availableCompanies={availableCompanies}
        onSubmit={handleAssignSubmit}
        isPending={isAssignTenantPending}
      />

      <AssignRoleDialog
        open={assignRoleModalVisible}
        onOpenChange={setAssignRoleModalVisible}
        user={selectedUser}
        onSubmit={handleAssignRoleSubmit}
        isPending={isAssignRolePending}
      />
    </Container>
  );
};
